import React from 'react';
// Components
import ManageStoreBio from 'components/common/ManageStoreBio';

const ManageOrganizationBio = (): JSX.Element => {
  return <ManageStoreBio />;
};

export default ManageOrganizationBio;
